import { render, staticRenderFns } from "./list-merge-widget.vue?vue&type=template&id=3520ba76&"
import script from "./list-merge-widget.vue?vue&type=script&lang=js&"
export * from "./list-merge-widget.vue?vue&type=script&lang=js&"
import style0 from "./list-merge-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports